import { ErrorHandler, Injectable } from '@angular/core';
import { TelemetryService } from './telemetry.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService extends ErrorHandler {
  constructor(private telemetryService: TelemetryService) {
    super();
  }

  override handleError(error: Error): void {
    this.telemetryService.logException(error);
    super.handleError(error);
  }
}
